import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CommonService} from './services/common.service';
import {TranslateService} from '@ngx-translate/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked, OnInit {
  title = 'app';
  constructor(
    public commonService: CommonService,
    public cdRef: ChangeDetectorRef,
    translate: TranslateService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    // Carga el idioma por defecto
    translate.setDefaultLang('en');
    translate.use('en');

    iconRegistry.addSvgIcon('targetSvg',sanitizer.bypassSecurityTrustResourceUrl('assets/static/target.svg'));
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.commonService.load = false;
    }, 3000);
  }

}
